export const destinatarioFormulario = Object.freeze({
    TODOS_LOS_COLABORADORES: "TODOS_LOS_COLABORADORES",
    SEDE: "CENTRO_DE_COSTO",
    COLABORADOR: "COLABORADOR",
    CARGA_EXCEL_DNIS: "CARGA_EXCEL_DNIS"
});